import { useEffect, useState } from 'react'
import { RefreshCw } from 'lucide-react'
import { Button } from '@shared/design-system/ui'
import { freshnessBar, freshnessStatus } from './dashboard.css'

export type FreshnessBarProps = {
  lastUpdatedAt: number
  isFetching: boolean
  onRefresh: () => void
}

function relativeTime(timestamp: number, now: number): string {
  if (timestamp <= 0) {
    return 'sem atualização'
  }

  const diffSeconds = Math.max(0, Math.round((now - timestamp) / 1000))
  if (diffSeconds < 60) {
    return 'agora'
  }

  const diffMinutes = Math.floor(diffSeconds / 60)
  return `há ${diffMinutes} min`
}

export function FreshnessBar({ lastUpdatedAt, isFetching, onRefresh }: FreshnessBarProps) {
  const [now, setNow] = useState(() => Date.now())

  useEffect(() => {
    const intervalId = window.setInterval(() => {
      setNow(Date.now())
    }, 30_000)

    return () => window.clearInterval(intervalId)
  }, [])

  const label = relativeTime(lastUpdatedAt, now)

  return (
    <div className={freshnessBar} data-testid="dashboard-freshness">
      <span className={freshnessStatus}>Atualizado {label}</span>
      <Button
        variant="secondary"
        size="sm"
        leftIcon={<RefreshCw size={14} />}
        disabled={isFetching}
        onClick={onRefresh}
        data-testid="dashboard-refresh-btn"
      >
        Atualizar
      </Button>
    </div>
  )
}
